import { log } from '~/utils/log';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

export type ArticleCardImpressionProperties = {
  article_id: string;
  module_position?: number;
  module_type: string;
  position: number;
};

type EventData = {
  articleId: string | undefined;
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: string;
  position: number;
};

class ArticleCardImpressionEvent extends ImpressionEvent<
  EventData,
  ArticleCardImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'article_card';
  }

  track() {
    if (this.data.isBot) return;

    if (!this.data.articleId) {
      log.error('ArticleCardImpressionEvent fired without an article_id', {
        module_type: this.data.moduleType,
        position: this.data.position
      });

      return;
    }

    super.track();
  }

  protected getImpressionProperties(): ArticleCardImpressionProperties {
    return {
      article_id: String(this.data.articleId),
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      position: this.data.position
    };
  }
}

export default ArticleCardImpressionEvent;
